{
  "duration-form": {
    "text": {
      "hour": "Heure",
      "minute": "Minute"
    }
  }
}
